import { render, staticRenderFns } from "./CPcSearchKit.vue?vue&type=template&id=0d9d8fd2&scoped=true&"
import script from "./CPcSearchKit.vue?vue&type=script&lang=ts&"
export * from "./CPcSearchKit.vue?vue&type=script&lang=ts&"
import style0 from "./CPcSearchKit.vue?vue&type=style&index=0&id=0d9d8fd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9d8fd2",
  null
  
)

export default component.exports